import { useContext } from 'react'
import { AuthContext } from '@/context/auth-context'
import { Navigate } from 'react-router-dom'
import AccountPage from '@/account/components/AccountPage'
import { OrganizationRosterEntrySource } from '@/analytics/enums/organization.enums'
import { organizationRosterLocationState } from '@/organizations/utils/organization-roster-navigation'

const AccountPageGuard = () => {
  const { user, userAccountData } = useContext(AuthContext)
  const isOrgAccount = userAccountData?.isOrgAccount
  const isOrgAdmin = userAccountData?.isOrgAdmin

  // Check that the user is logged in
  if (userAccountData && user && !user.isAnonymous) {
    // Individual accounts see the account page
    if (!isOrgAccount) return <AccountPage />

    // Org admins are redirected to the admin dashboard
    if (isOrgAccount && isOrgAdmin) {
      return <Navigate to="/dashboard/matters" replace state={organizationRosterLocationState(OrganizationRosterEntrySource.AccountPage)} />
    }
  }

  // Everything else falls back to the dashboard
  return <Navigate to="/dashboard" replace />
}

export default AccountPageGuard
